// easyui-panel.component.ts
// (c) 2016 EvoluS Srl
// (a) VG

import { Component, ElementRef, AfterViewInit, Input, ViewChild } from '@angular/core';

declare let $: any;

@Component({
  selector: 'easyui-panel',
  template: `
  <div style="height: 100%">
    <div #host>
      <ng-content></ng-content>
    </div>
  </div>
  `
})
export class EasyuiPanelComponent implements AfterViewInit {
  private host: any;
  @Input('options') options: any = {};
  @Input() width: number;
  @Input() height: number;
  @ViewChild('host') hostElement: ElementRef;

  constructor() {
  }

  ngAfterViewInit() {
    this.configura(this.options);
  }

  // metodi pubblici

  public open() {
    this.host.panel('open');
  }

  public close() {
    this.host.panel('close');
  }

  public doLayout() {
    this.host.panel('doLayout');
  }

  // css(selector: string, property: string, value: string) {
  //   this.host.find(selector).css(property, value)
  // }

  public styleElement( tag: string, css: any) {
    const element = this.host.find(tag);
    element.css(css);
  }

  // metodi privati

  private configura(options: any) {
    this.host = $(this.hostElement.nativeElement);
    this.host.panel(options);
  }
}



// WEBPACK FOOTER //
// ./src/app/easyui-ts/easyui-panel.component.ts